export default {
    CARD_SIZE_CONFIG: {
        cardsPerSlide: 4,
        cardWidth: [146, 175]
    }
};
